import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";
import { DashboardResponse } from '../../../api/models/dashboardResponse';
import { RouteURLConstants } from '../../../constants/upplm.constants';
import { DASHBOARD_SECTIONS, PLACARD_STATUS } from '../../../constants/upplm.constants.dashboard';
import { DAYS_SHORTCODE_TRANSLATION } from '../../../constants/upplm.constants.pickupdetails';
import { PICKUP_LOCATION_KEY, PLACARD_LOCATION } from '../../../constants/upplm.constants.placardlocation';
import { Contact, PlacardDetails, PlacardLocation } from '../../../interface/upplm.placardInformation';
import { TranslateDataPipe } from '../../../pipes/translation.pipe';
import { UpsCommonService } from '../../../services/upplm.common.service';
import { UpsDashboardService } from '../../../services/upplm.dashboard.service';


@Component({
    selector: 'additional-detail',
    template: require('./additional-detail.component.html')
})

export class AdditionalDetailComponent {

    @Input() status: any;
    @Input() dashboardData: DashboardResponse;
    locationDetails: boolean = false;
    contactDetails: boolean = false;
    placardDetails: boolean = false;
    pickupDetails: boolean = false;
    notifications: boolean = false;
    placardVerification: boolean = false;
    placardLocation: boolean = false;
    verificationNeeded: boolean = false;
    public showRequestorContact: boolean = false;
    public showPrimaryContact: boolean = false;
    public requestor: Contact = new Contact();
    primary: Contact = new Contact();
    public multiOffice: string = '';
    public urlImage: string = '';
    public isLockedContainer: string = '';
    public formatedStartDate: string = '';
    public scheduleDays: string[] = [];
    dashboardSections: string[] = [];
    public paramsUrl: string = '?loc=en_US&placardid=';
    placardCountryCode: string = '';
    notificationsDetail: string[] = [];
    shipmentType: string = '';
    placardSize: string = '';
    pickupLocation: string = '';
    placardLocationDesc: string = '';

    constructor(private router: Router,
        private _dashboardService: UpsDashboardService,
        private _translate: TranslateDataPipe,
        private _commonService: UpsCommonService
    ) { }

    ngOnChanges() {
        if (typeof this.dashboardData !== 'undefined' && Object.keys(this.dashboardData).length > 0) {
            this.getSections(this.dashboardData.placardStatus);
        }
    }

    getSections(status: string) {
        if (status === PLACARD_STATUS.CANCELLED) { //Load 5 or 7 sections depending if status is cancelled
            if (this.dashboardData.isHung) { //If is cancelled and hung, load 7 sections of dashboard
                this.dashboardSections = this._dashboardService.getDashboardSectionsByStatus(status);
            }
            else {//cancelled and not hung, load only 5 sections of the dashboard
                this.dashboardSections = this._dashboardService.getDashboardSectionsByStatus(PLACARD_STATUS.CANCELLED_NO_HUNG);
            }
        }
        else {//Status is not cancelled, proceed with section loading according to status
            this.dashboardSections = this._dashboardService.getDashboardSectionsByStatus(status);
        }
        this.setValueToSections();
        this.getAndCompareContacts();
        this.getMultiOffice();
        this.getURLPicture();
        this.getLockedContainer();
        this.getScheduleDays();
        this.placardCountryCode = this.dashboardData.placardInformation.locationDetails.address.countryCode;
        this.notificationsDetail = this.changeNotificationsMailLegend(this.dashboardData.placardInformation.notifications);
        this.getPlacardDetails();
        this.getPlacardLocationDetails();
    }

    getScheduleDays() {
        this.scheduleDays = [];
        this.dashboardData.placardInformation.pickupDetails.selectedDays.forEach(function (selectedDay) {
            const day = DAYS_SHORTCODE_TRANSLATION.find(x => x.dayshortcode === selectedDay.dayOfWeekCode).key;
            this.scheduleDays.push(`${this._translate.transform(day)} ${selectedDay.selectedPreferredTime} - ${selectedDay.selectedLatestTime}`);
        }, this)     
    }

    getLockedContainer() {
        if (this.dashboardData.placardInformation.placardLocation) {
            this.isLockedContainer = this.dashboardData.placardInformation.placardLocation.metalBoxInd === true ? this._translate.transform('upplm.common.yes') : this._translate.transform('upplm.common.no');
        }
    }

    setValueToSections() {
        this.locationDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.LOCATION_DETAILS) > -1 ? true : false;
        this.contactDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.CONTACT_DETAILS) > -1 ? true : false;
        this.placardDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PLACARD_DETAILS) > -1 ? true : false;
        this.pickupDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PICKUP_DETAILS) > -1 ? true : false;
        this.notifications = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.NOTIFICATIONS) > -1 ? true : false;
        this.placardVerification = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PLACARD_VERIFICATION) > -1 ? true : false;
        this.placardLocation = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PLACARD_LOCATION) > -1 ? true : false;
        this.verificationNeeded = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.VERIFICATION_NEEDED) > -1 ? true : false;
    }

    getURLPicture() {
        if (this.dashboardData.placardInformation.placardVerification) {
            if (this.dashboardData.placardInformation.placardVerification.placardImage) {
                this.urlImage = 'data:' + this.dashboardData.placardInformation.placardVerification.placardImage.extension + ';base64,' + this.dashboardData.placardInformation.placardVerification.placardImage.contents;
            }
        }
    }

    public openPicture() {
        var newTab = window.open();
        newTab.document.body.innerHTML = '<img src="' + this.urlImage.trim() + '"' + ' width="80%" height="80%">';
    }

    getAndCompareContacts() {

        this.primary = new Contact();
        this.requestor = new Contact();

        this.showRequestorContact = true;
        this.showPrimaryContact = true;
        
            for (let i in this.dashboardData.placardInformation.contactDetails) {
                if (this.dashboardData.placardInformation.contactDetails[i].contactType === '02') { //Primary Contact
                    this.primary.email = this.dashboardData.placardInformation.contactDetails[i].email;
                    this.primary.name = this.dashboardData.placardInformation.contactDetails[i].name;
                    this.primary.phone = this.dashboardData.placardInformation.contactDetails[i].phone;
                    this.primary.phoneExt = this.dashboardData.placardInformation.contactDetails[i].phoneExt;
                    this.primary.locale = this.dashboardData.placardInformation.contactDetails[i].locale;
                    
                }
                else if (this.dashboardData.placardInformation.contactDetails[i].contactType === '01') { // Requestor Contact
                    this.requestor.email = this.dashboardData.placardInformation.contactDetails[i].email;
                    this.requestor.name = this.dashboardData.placardInformation.contactDetails[i].name;
                    this.requestor.phone = this.dashboardData.placardInformation.contactDetails[i].phone;
                    this.requestor.phoneExt = this.dashboardData.placardInformation.contactDetails[i].phoneExt;
                    this.requestor.locale = this.dashboardData.placardInformation.contactDetails[i].locale;
            }
        }
        if (this.primary.email == "") {
            this.showPrimaryContact = false;
        } 

        if (Object.keys(this.requestor).length > 0) {
            if (this.primary.email === this.requestor.email && this.primary.name === this.requestor.name && this.primary.phone === this.requestor.phone && this.primary.phoneExt === this.requestor.phoneExt) {
                this.showRequestorContact = false;
            }
        }
        else {
            this.showRequestorContact = false;
        }
    }

    getMultiOffice() {
        this.multiOffice = this.dashboardData.placardInformation.placardDetails.locationType === 'Single Location' ? this._translate.transform('upplm.common.no') : this._translate.transform('upplm.common.yes');
    }

    goToPlacardVerification() {
        this.router.navigateByUrl(`${RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE}?loc=${this._commonService.locale}&placardid=${this.dashboardData.placardId}`);
    }

    changeNotificationsMailLegend(notificationsToChange: Contact[]):string[] {
        let changes: string[] = [];
        if (this.showPrimaryContact) {
            changes.push(`${this.primary.email} - ${this.getPosEmailValue(this.primary.locale)}`);
        }
        if (this.showRequestorContact) {
            changes.push(`${this.requestor.email} - ${this.getPosEmailValue(this.requestor.locale)}`);
        }
        if (notificationsToChange) {
            notificationsToChange.forEach(function (email) {
                changes.push(`${email.email} - ${this.getPosEmailValue(email.locale)}`);
            }, this);
        }
        return changes;
    }

    getPosEmailValue(emailLocale: string): string {
        if (emailLocale === 'en_US' || (emailLocale !== 'fr_CA' && emailLocale !== 'en_CA')) {
            return `US ${this._translate.transform('upplm.common.english')}`;
        }
        if (emailLocale === 'fr_CA' || emailLocale === 'en_CA') {
            return `CA ${this._translate.transform('upplm.common.englishfrench')}`;
        }
    }

    getPlacardDetails() {
        if (this.validatePlacardDetails(this.dashboardData.placardInformation.placardDetails)) {
            if (this.dashboardData.placardInformation.placardDetails.placardSize.includes('Portrait')) {
                this.placardSize = this.dashboardData.placardInformation.placardDetails.placardSize.replace("Portrait", this._translate.transform('upplm.placarddetails.portrait'));
            } else if (this.dashboardData.placardInformation.placardDetails.placardSize.includes('Landscape')) {
                this.placardSize = this.dashboardData.placardInformation.placardDetails.placardSize.replace("Landscape", this._translate.transform('upplm.placarddetails.landscape'))
            }
            this.translateShipmentType(this.dashboardData.placardInformation.placardDetails.placardType.trim());
        }
    }

    validatePlacardDetails(placardDetails: PlacardDetails): boolean {
        if (!(placardDetails !== null ||
            (typeof placardDetails !== 'undefined' && placardDetails))) {
            return false;
        }
        return true;
    }

    translateShipmentType(shipmentType: string) {
        if (shipmentType === 'LAB SPECIMEN') {
            this.shipmentType = this._translate.transform('upplm.placarddetails.labspecimen').toUpperCase();
        }
        if (shipmentType === 'NON-LAB') {
            this.shipmentType =  this._translate.transform('upplm.placarddetails.nonlab').toUpperCase();
        }
    }

    getPlacardLocationDetails() {
        if (this.validatePlacardLocationDetails(this.dashboardData.placardInformation.placardLocation)) {
            this.placardLocationDesc = this.translatePlacardLocation(this.dashboardData.placardInformation.placardLocation.placardLocation);
            this.pickupLocation = this.translatePickupLocation(this.dashboardData.placardInformation.placardLocation.pickupLocation);
        }
    }

    validatePlacardLocationDetails(placardLocationDetails: PlacardLocation) {
        if (!(placardLocationDetails !== null ||
            (typeof placardLocationDetails !== 'undefined' && placardLocationDetails))) {
            return false;
        }
        return true;
    }

    translatePlacardLocation(value: string): string {
        if (PLACARD_LOCATION.find(x => x.key.trim().toLowerCase() === value.trim().toLowerCase())) {
            return this._translate.transform(PLACARD_LOCATION.find(x => x.key.trim().toLowerCase() === value.trim().toLowerCase()).value);
        } else {
            return value;
        }
    }

    translatePickupLocation(value: string): string {
        return this._translate.transform(PICKUP_LOCATION_KEY.find(x => x.key.toLowerCase() === value.trim().toLowerCase()).value);
    }
}